import { render, staticRenderFns } from "./SendLetterOrEmail.vue?vue&type=template&id=9a819b3c&"
import script from "./SendLetterOrEmail.vue?vue&type=script&lang=js&"
export * from "./SendLetterOrEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendLetterOrEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports